module.exports = __webpack_public_path__ + "images/03b33f3251599f6a7ecff86d59626553-bermuda.png";